"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _OzContainer = _interopRequireDefault(require("./../OzContainer/OzContainer.js"));

var __jsx = _react.default.createElement;

// import {GHOSTWHITE} from "./../consts.js";
var Wrapper = _styledComponents.default.div.withConfig({
  displayName: "OzLabelMenu__Wrapper",
  componentId: "sc-1n90qe9-0"
})(["\n  margin-bottom: -1px;\n  overflow: hidden;\n"]); // const Item = styled.div`
//   display: inline-block;
//   margin-right: 5px;
//   font-size: 13px;
//   font-weight: 600;
//   color: ${props => props.isActive ? "#303030" : "#30303050"};
//
//
//   box-shadow: 0px 2px 16px ${props => props.isActive ? "#C1CCE838" : "transparent"};
//   padding: 8px 20px;
//   background-color: ${props => props.isActive ? "#ffffff" : "transparent"};
//   border-top-left-radius: 4px;
//   border-top-right-radius: 4px;
//   cursor: ${props => props.isActive ? "default" : "pointer"};
//
//   &:hover{
//     background-color: ${props => props.isActive ? "#ffffff" : "#ffffff99"};
//   }
//
// `;


var OzLabelMenu = function OzLabelMenu(_ref) {
  var items = _ref.items;
  return __jsx(Wrapper, null, __jsx(_OzContainer.default, null, items.map(function (item, i) {
    return __jsx("div", {
      key: i
    });
  })));
};

var _default = OzLabelMenu;
exports.default = _default;